function i(r, ...e) {
  if (Array.isArray(r))
    r.forEach((a) => i(a, ...e));
  else
    return r(...e);
}
export {
  i as call
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/vue/call.js
// module id = 34
// module chunks = 41